export default __webpack_public_path__ + "static/media/malaysia1.1acb3cf9.jpg";